import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  MenuItem,
  Paper,
  Switch,
  FormControlLabel,
  TextField,
  Typography,
  Divider,
  CircularProgress,
} from "@mui/material";
import { apiFetch } from "./utils/apiClient";
const API_BASE =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000/api"
    : "https://artikaorder-backend.onrender.com/api";

const defaultSettings = {
  title: "Artika AI Assistant",
  welcomeMessage: "ارفع صورة جدار الزبون",
  enabled: true,

  textModel: "gpt-4.1-mini",
  imageModel: "gpt-image-1",
  temperature: 0.3,

  maxWallImages: 1,
  maxOptionImages: 6,

  option1Label: "ارفع صورة اللوحة التي يريدها الزبون",
  option2Label: "ارفع صورة اللوحة التي يرغبها الزبون لكن غير ألوان",
  option3Label: "ارفع الـ inspiration images",
  option4Label: "اكتب فكرة اللوحة التي يريدها الزبون",

  commonPrompt: `أنت مساعد ذكي داخل نظام Artika.
أجب باللغة العربية بشكل واضح، ذكي، مختصر، وعملي.
حلل الصور والنصوص المرسلة من المستخدم بدقة.
إذا كانت المهمة تحتاج اقتراحات تصميم أو تنسيق، فقدم اقتراحات واضحة ومنظمة.
إذا كانت هناك ملفات أو صور، استخدمها كأساس للإجابة.
كن مفيدًا ومباشرًا واحترافيًا.`,

  wallPrompt: `عند رفع صورة الجدار:
1) حلل شكل الجدار والمساحة الظاهرة.
2) وضّح إن كان الجدار مناسبًا للوحات كبيرة أو متوسطة أو مجموعة لوحات.
3) اقترح ستايل عام مناسب للمكان.
4) أعطِ ملاحظة مختصرة تساعد الموظف قبل الانتقال للمرحلة التالية.
5) إذا أمكن، جهّز اقتراحًا بصريًا مناسبًا.`,

  option1Prompt: `هذه الحالة تعني أن المستخدم رفع صورة اللوحة التي يريدها الزبون.
اعتمد على صورة الجدار السابقة + صورة/صور اللوحة الجديدة.
المطلوب:
1) حلل هل اللوحة مناسبة للجدار.
2) اقترح أفضل شكل لعرضها داخل المساحة.
3) أعطِ وصفًا واضحًا ومختصرًا.
4) إذا أمكن، أنشئ نتيجة بصرية مناسبة + نص واضح.`,

  option2Prompt: `هذه الحالة تعني أن المستخدم رفع صورة لوحة يريدها الزبون لكن مع تغيير الألوان.
اعتمد على صورة الجدار السابقة + صورة/صور اللوحة الجديدة + ملاحظة المستخدم.
المطلوب:
1) الحفاظ على الفكرة أو الستايل العام.
2) اقتراح ألوان أنسب حسب الجدار أو المكان.
3) شرح سبب اختيار الألوان باختصار.
4) إذا أمكن، أنشئ نتيجة بصرية مناسبة + نص واضح.`,

  option3Prompt: `هذه الحالة تعني أن المستخدم رفع inspiration images.
اعتمد على صورة الجدار السابقة + صور الإلهام.
المطلوب:
1) استخرج الستايل العام من الصور.
2) قدّم فكرة متناسقة مع الجدار.
3) لا تنسخ الصور مباشرة، بل استلهم منها.
4) قدّم نتيجة بصرية مناسبة + نص واضح ومختصر.`,

  option4Prompt: `هذه الحالة تعني أن المستخدم كتب فكرة اللوحة التي يريدها الزبون.
اعتمد على صورة الجدار السابقة + النص المكتوب + أي صور مرفقة.
المطلوب:
1) فهم الفكرة جيدًا.
2) تحويلها إلى تصور عملي ومناسب للجدار.
3) اقتراح ستايل أو ألوان أو توزيع إن لزم.
4) قدّم نتيجة بصرية مناسبة + نص واضح ومختصر.`,
};

const AdminAIPromptPanel = () => {
  const [form, setForm] = useState(defaultSettings);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const username = localStorage.getItem("username");
const promptFieldSx = {
  mb: 4,
  "& .MuiInputBase-root": {
    height: 260,
    alignItems: "flex-start",
  },
  "& textarea": {
    height: "100% !important",
    overflowY: "auto !important",
    resize: "none",
  },
};
  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const loadSettings = async () => {
    try {
      setLoading(true);

      const res = await apiFetch(`${API_BASE}/ai/prompt`);
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "حدث خطأ أثناء تحميل إعدادات الذكاء الاصطناعي");
      }

      setForm({
        ...defaultSettings,
        ...data,
      });
    } catch (error) {
      console.error("Error loading AI settings:", error);
      alert("❌ حدث خطأ أثناء تحميل إعدادات الذكاء الاصطناعي");
    } finally {
      setLoading(false);
    }
  };

  const saveSettings = async () => {
    try {
      setSaving(true);

      const res = await apiFetch(`${API_BASE}/ai/prompt`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...form,
          updatedBy: username || "admin",
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "حدث خطأ أثناء حفظ الإعدادات");
      }

      alert("✅ تم حفظ إعدادات الـ AI بنجاح");
    } catch (error) {
      console.error("Error saving AI settings:", error);
      alert("❌ حدث خطأ أثناء حفظ الإعدادات");
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    loadSettings();
  }, []);

  if (username !== "admin") {
    return (
      <Container sx={{ mt: 5 }}>
        <Paper sx={{ p: 4, textAlign: "center" }}>
          <Typography variant="h6" color="error">
            ليس لديك صلاحية الوصول إلى هذه الصفحة
          </Typography>
        </Paper>
      </Container>
    );
  }

  if (loading) {
    return (
      <Container sx={{ mt: 8, textAlign: "center" }}>
        <CircularProgress />
        <Typography sx={{ mt: 2 }}>جاري تحميل إعدادات الـ AI...</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          🤖 إعدادات Artika AI - Admin Panel
        </Typography>

        <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
          من هذه الصفحة المدير يگدر يتحكم بكل البرومبتات والإعدادات الخاصة
          بواجهة الذكاء الاصطناعي.
        </Typography>

        <Box sx={{ mb: 3, display: "flex", gap: 2, flexWrap: "wrap" }}>
          <Button variant="contained" onClick={saveSettings} disabled={saving}>
            {saving ? "جاري الحفظ..." : "💾 حفظ الإعدادات"}
          </Button>

          <Button variant="outlined" onClick={loadSettings}>
            🔄 إعادة تحميل
          </Button>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
          الإعدادات العامة
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="عنوان الواجهة"
              value={form.title}
              onChange={(e) => handleChange("title", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="الرسالة الأولى للمستخدم"
              value={form.welcomeMessage}
              onChange={(e) => handleChange("welcomeMessage", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              select
              fullWidth
              label="مودل النص"
              value={form.textModel}
              onChange={(e) => handleChange("textModel", e.target.value)}
            >
              <MenuItem value="gpt-4.1-mini">gpt-4.1-mini</MenuItem>
              <MenuItem value="gpt-4.1">gpt-4.1</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="مودل الصور"
              value={form.imageModel}
              onChange={(e) => handleChange("imageModel", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Temperature"
              value={form.temperature}
              onChange={(e) => handleChange("temperature", Number(e.target.value))}
              inputProps={{ step: 0.1, min: 0, max: 1 }}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              type="number"
              label="عدد صور الجدار المسموح"
              value={form.maxWallImages}
              onChange={(e) => handleChange("maxWallImages", Number(e.target.value))}
              inputProps={{ min: 1 }}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              type="number"
              label="عدد الصور بباقي الخيارات"
              value={form.maxOptionImages}
              onChange={(e) =>
                handleChange("maxOptionImages", Number(e.target.value))
              }
              inputProps={{ min: 1 }}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControlLabel
              control={
                <Switch
                  checked={form.enabled}
                  onChange={(e) => handleChange("enabled", e.target.checked)}
                />
              }
              label={form.enabled ? "الواجهة مفعّلة" : "الواجهة متوقفة"}
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
          أسماء الخيارات التي تظهر للمستخدم
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="الخيار الأول"
              value={form.option1Label}
              onChange={(e) => handleChange("option1Label", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="الخيار الثاني"
              value={form.option2Label}
              onChange={(e) => handleChange("option2Label", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="الخيار الثالث"
              value={form.option3Label}
              onChange={(e) => handleChange("option3Label", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="الخيار الرابع"
              value={form.option4Label}
              onChange={(e) => handleChange("option4Label", e.target.value)}
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
          البرومت العام
        </Typography>

        <TextField
          fullWidth
          multiline
          minRows={8}
          label="Common Prompt"
          value={form.commonPrompt}
          onChange={(e) => handleChange("commonPrompt", e.target.value)}
           sx={promptFieldSx}
        />

        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
          برومت السؤال الأول - صورة الجدار
        </Typography>

        <TextField
          fullWidth
          multiline
          minRows={8}
          label="Wall Prompt"
          value={form.wallPrompt}
          onChange={(e) => handleChange("wallPrompt", e.target.value)}
          sx={promptFieldSx}
        />

        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
          برومت الخيار الأول
        </Typography>

        <TextField
          fullWidth
          multiline
          minRows={8}
          label="Option 1 Prompt"
          value={form.option1Prompt}
          onChange={(e) => handleChange("option1Prompt", e.target.value)}
            sx={promptFieldSx}
        />

        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
          برومت الخيار الثاني
        </Typography>

        <TextField
          fullWidth
          multiline
          minRows={8}
          label="Option 2 Prompt"
          value={form.option2Prompt}
          onChange={(e) => handleChange("option2Prompt", e.target.value)}
          sx={promptFieldSx}
        />

        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
          برومت الخيار الثالث
        </Typography>

        <TextField
          fullWidth
          multiline
          minRows={8}
          label="Option 3 Prompt"
          value={form.option3Prompt}
          onChange={(e) => handleChange("option3Prompt", e.target.value)}
          sx={promptFieldSx}
        />

        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
          برومت الخيار الرابع
        </Typography>

        <TextField
          fullWidth
          multiline
          minRows={8}
          label="Option 4 Prompt"
          value={form.option4Prompt}
          onChange={(e) => handleChange("option4Prompt", e.target.value)}
          sx={promptFieldSx}
        />
      </Paper>
    </Container>
  );
};

export default AdminAIPromptPanel;